import React from 'react'
import Head from 'react-helmet';

export default function HtmlHead(props) {
  let { title } = props

  return (
    <Head>
      <html lang="en" /> {/* this is valid react-helmet usage! */}
      <title>{`${title} | Reason SLS`}</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Head>
  )
}



// WEBPACK FOOTER //
// ./component/ui/HtmlHead.js